import { IconClose16 } from '@warp-ds/icons/react';
import cn from 'classnames';
import { type KeyboardEvent, useRef } from 'react';

import styles from './CloseButton.module.css';

interface CloseButtonProps {
    onClick: () => void;
    setOpen: (open: boolean) => void;
    className?: string;
}

export const CloseButton = ({ onClick, setOpen, className }: CloseButtonProps) => {
    const closeButtonRef = useRef<HTMLButtonElement>(null);

    const handleCloseClick = () => {
        onClick();
        setOpen(false);
    };

    const handleKeyDown = (event: KeyboardEvent<HTMLButtonElement>) => {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            handleCloseClick();
        }
    };

    return (
        <button
            type="button"
            className={cn(styles['close-button'], className)}
            ref={closeButtonRef}
            aria-label="Lukk"
            onClick={handleCloseClick}
            onKeyDown={handleKeyDown}>
            <IconClose16 aria-hidden="true" focusable="false" />
        </button>
    );
};
